// import React from 'react'

import img1 from "../../media/images/GurugramContent1.jpg";
import img2 from "../../media/images/GurugramContent2.jpg";

const LocationContentGhaziabad = () => {
  return (
    <div>
      <div className="location-content">
        <div className="location-content-main">
          <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
          </div>

          <div className="location-content-section">
            <h3 className="location-content-heading">
              🐾 Premium At-Home <span>Pet Grooming</span> Across <span>Ghaziabad</span> | FluffyTouch
            </h3>
            <div className="location-content-text">

              "From Indirapuram to Crossings Republik - We Serve Every Paw in Ghaziabad!"
              📞 Direct Booking: 96581 89189 | 🌐 Areas Covered: All sectors, colonies & societies.
              Tired of struggling with messy bathtubs or anxious car rides to salons? Our home pet grooming service in Ghaziabad brings the spa to your doorstep!
            
            </div>

            <div className="location-content-image">
              <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
            </div>

            <section>
              <div className="location-content-sub-heading">
                Ghaziabad-Wide Pet Care Solutions
              </div>
              <div className="location-content-text">
                ✔ For High-Rises (Nyay Khand, Ahinsa Khand) - Elevator-friendly equipment
<br />✔ For Villas (Vaishali, Raj Nagar) - Garden grooming setups
<br />✔ For New Areas (Crossings Republik, Govind Puram) - Special weekend slots

              </div>

              <div className="location-content-sub-heading">
               Why Entire Ghaziabad Trusts Us?
              </div>
              <div className="location-content-text">
                <ul>
<li>City-Wise Scheduling: Morning slots for East Ghaziabad (Vasundhara), evenings for West (Crossings Republik)</li>
<li>Monsoon Ready: Anti-tick treatments before rainy season</li>
<li>Festival Specials: Diwali/Christmas grooming packages</li>
                </ul>
                
              </div>

              <div className="location-content-sub-heading">
                Ghaziabad Pet Parent Stories
              </div>
              <div className="location-content-text">
              "Finally found groomers who come to my Crossings Republik society!" - Rohan, Sector 16
              <br />
              "My Persian cat's mats disappeared without stress!" - Priya, Kaushambi Tower
              </div>

              <div className="location-content-sub-heading">
               Why Pet Parents Trust Us
              </div>
              <div className="location-content-text">
  ✓ Ghaziabad's Most Experienced Team
<br />✓ Vet-Approved Products
<br />✓ 100% Van-Free Service (We bring compact kits)
<br />✓ Emergency Slot Availability
<br />"My Shih Tzu used to hide at salon visits - now he wags his tail when the groomer arrives!"

              </div>
            </section>

        

            <div className="location-content-sub-heading"></div>
            <div className="location-content-text"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationContentGhaziabad;
